/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_ValueInputs */

const cs_contacts_value = /** @type {(inputs: Contacts_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota`)
};

const en_contacts_value = /** @type {(inputs: Contacts_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Contacts_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_value = /** @type {((inputs?: Contacts_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_value(inputs)
	return cs_contacts_value(inputs)
});